/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useEffect} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as actions from '../../../app/modules/Sale/_redux/orderlines/orderlinesActions';
import {Link} from "react-router-dom";

export function DropdownMenu1() {
    
    const {lastOrder, orderlines} = useSelector(
        (state) => ({
            lastOrder: state.orders.lastOrder,
            orderlines: state.orderlines.entities
        }),
        shallowEqual
    );
    
    const dispatch = useDispatch();

    useEffect(() => {
        if(lastOrder){
            dispatch(actions.getOrderlines(lastOrder.id));
        }
    }, [lastOrder, dispatch]);
    
    
    
    return (<>
        {/*begin::Navigation*/}
        <ul className="navi navi-hover">
            {orderlines && orderlines.slice(0, 3).map(order => (
                <li key={order.id}
                    className={"navi-header border-bottom font-weight-bold py-5 d-flex justify-content-between align-items-center"}>
                    <span>{order.productName}</span>
                    <span>تعداد: {order.qty}</span>
                </li>
            ))}
            <li
                className={"navi-header border-bottom font-weight-bold py-5 d-flex justify-content-between align-items-center"}>
                <span>....</span>
            </li>

            <li className="navi-footer pt-5 pb-4">
                <Link to={"/sales/orders/cart"} className="btn btn-primary font-weight-bold btn-sm" href="#">
                    مشاهده کامل سفارش
                </Link>
            </li>
        </ul>
        {/*end::Navigation*/}
    </>);
}
